// A Claude conversation's Home row waits on you only when a device can answer it (Josh 10-16: the phone listed three
// "waiting on you" nobody could act on — terminals Cody didn't start, idle at their prompt or stopped 13 h ago). The
// same rule as the Mac's glance (GlanceClaude.actionable): Cody hosts it (`host: 'cody'` — a Cody-run claude, or Cody's
// own terminal), nothing else holds it (not `viewOnly`, not `inTerminal`), it asks something (`asks`: a permission
// card or a question — never a bare "needs you"), its last record is under a day old, and its claude still runs (or
// its card is still open). Any other row keeps its badge's words but is not waiting: not in Needs you, not counted.
//
// Seams: `isClaudeRow(row)` — a Claude conversation's row (its id and kind; the web names no extension);
// `claudeWaits(row, now)`; home.js `items` maps a Claude row that fails it from needsYou to idle.
export const isClaudeRow = (row) => /^(session|conversation):./.test(String(row?.id || '')) && /^Claude (app|Code)$/.test(String(row?.kind || ''))
export const STALE_MS = 24 * 3600e3

export function claudeWaits(row, now = Date.now()) {
  if (row?.status !== 'needsYou') return false
  if (row.host !== 'cody' || row.viewOnly || row.inTerminal || !row.asks) return false
  const t = typeof row.time === 'number' ? (row.time < 1e12 ? row.time * 1000 : row.time) : 0
  if (t && now - t > STALE_MS) return false
  if (row.claudeRunning === false && row.asks?.hook?.state !== 'open') return false
  return true
}
